import {useQuery} from "@tanstack/react-query";
import {AccountSearchInterface} from "../../correspondent/list/interface/searchInterface";
import {readProjectListApi} from "../../../../api/correspondent/projectApi";

type Props = {
    searchData: AccountSearchInterface;
};

export const useReadProjectList = ({searchData}: Props) => {
    const {data} = useQuery({
        queryKey: ["readProjectList", searchData],
        queryFn: async () => await readProjectListApi(searchData),
        select: (res) => res?.result,
    });
    return {data};
};
